import { authByToken } from 'src/apollo/auth/auth-by-token'
import { consoleLogAPI } from 'src/common/functions'
import { authBySession } from 'src/apollo/auth/auth-by-session'
import { getConfig } from 'src/configs'

const config = getConfig()

export default async function (store, apolloClient) {
  try {
    if (config.authBySession) {
      const isSuccessAuthBySession = await authBySession(store, apolloClient)

      if (!isSuccessAuthBySession) {
        await authByToken(store, apolloClient)
      }
    } else {
      await authByToken(store, apolloClient)
    }
  } catch (e) {
    consoleLogAPI(e)
  }
}
